import { useState } from 'react'
import { Link } from 'react-router-dom'
import './Login.css'

export default function PasswordReset() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    // デモ用：実際のAPIコールをシミュレート
    await new Promise((resolve) => setTimeout(resolve, 1000))
    
    setSubmitted(true)
    setLoading(false)
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <header className="login-header">
          <h1 className="login-title">FMT-Japan</h1>
          <p className="login-subtitle">一般財団法人腸内フローラ移植臨床研究会</p>
        </header>

        <main className="login-main">
          <h2 className="login-heading">パスワード再発行</h2>

          {submitted ? (
            <div className="password-reset-success">
              <span className="material-symbols-outlined">check_circle</span>
              <p>
                <strong>{email}</strong> 宛にパスワード再設定用のメールを送信しました。
              </p>
              <p>メールに記載されたリンクからパスワードを再設定してください。</p>
              <Link to="/login" className="aip-button aip-button--solid-fill aip-button--full-width">
                ログイン画面に戻る
              </Link>
            </div>
          ) : (
            <>
              <p className="password-reset-description">
                登録されているメールアドレスを入力してください。
                パスワード再設定用のリンクをお送りします。
              </p>

              <form onSubmit={handleSubmit} className="login-form">
                <div className="aip-floating-field">
                  <label className="aip-floating-field__label" htmlFor="email">
                    メールアドレス
                  </label>
                  <input
                    className="aip-floating-field__control aip-input-text"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="example@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                  />
                </div>

                <button
                  type="submit"
                  className="aip-button aip-button--solid-fill aip-button--full-width"
                  disabled={loading}
                >
                  {loading ? '送信中...' : '再設定メールを送信'}
                </button>
              </form>

              <div className="login-footer">
                <Link to="/login" className="aip-link">
                  ログイン画面に戻る
                </Link>
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  )
}




